//DropdownCriteria.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as SalesSearch from "./SalesSearch";
import * as SalesSearchSettings from "./SalesSearchSettings";
import * as Util from "../Util/Util";
import * as Util_MUI from "../Util/Util_MUI";

import { Icon, IconButton, TextField } from "@mui/material";

import React from "react";

let ss: SalesSearchSettings.iSS; //Settings.
let clearDropdownsDisabled: boolean = true;

//Clear dropdown criteria.
export function clearDropdownCriteria() {
   const propTypeSpec: SalesSearchSettings.iPropType = SalesSearchSettings.getPropTypeSpec(SalesSearch.propertyType);
   const omitImprove: SalesSearchSettings.iOmitImproveTypeCriteria = SalesSearchSettings.getOmitImproveTypeSpec(SalesSearch.improvementType);

   for (const criteriaKey of propTypeSpec.criteriaKeys) {
      if (omitImprove && omitImprove.criteriaKeys.Contains(criteriaKey)) {
         continue;
      }

      const criteria: SalesSearchSettings.iCriteriaDropdown = ss[criteriaKey];
      if (criteria && criteria.values) {
         criteria.value = criteria.values[0]; // criteria.defaultValue;
      }
   }

   clearDropdownsDisabled = true;
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   Util.logMsg("Top of DropdownCriteria.Render");

   //Initialize only one time.
   if (typeof ss === "undefined") {
      ss = SalesSearchSettings.ss; //Get settings.
   }

   //Wire up component for each time render is called, but not on refresh.
   const [initComponent, setState] = React.useState(() => {
   });

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Dropdown criteria changed.
   function dropdownCriteriaChanged(criteriaKey: string, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
      const criteria: SalesSearchSettings.iCriteriaDropdown = ss[criteriaKey];
      criteria.value = event.target.value;
      clearDropdownsDisabled = false;
      SalesSearch.autoSearch();
      refresh();
   }

   function clearAllDropdownCriteria() {
      clearDropdownCriteria();
      refresh();
   }

   //Get dropdown filters.
   function getDropdownFilters() {
      const jsx: JSX.Element[] = [];
      const propTypeSpec: SalesSearchSettings.iPropType = SalesSearchSettings.getPropTypeSpec(SalesSearch.propertyType);
      const omitImprove: SalesSearchSettings.iOmitImproveTypeCriteria = SalesSearchSettings.getOmitImproveTypeSpec(SalesSearch.improvementType);

      let i = 0;
      for (const criteriaKey of propTypeSpec.criteriaKeys) {
         i++;

         if (omitImprove && omitImprove.criteriaKeys.Contains(criteriaKey)) {
            continue;
         }

         const criteria: SalesSearchSettings.iCriteriaDropdown = ss[criteriaKey];
         const key: string = "dropdownCriteria_" + criteriaKey.replace(/ /g, '_');

         if (criteria && criteria.values) {
            jsx.push(
               <tr key={key}>
                  <td style={{ paddingRight: 9 }}>{criteria.alias}</td>

                  <td>
                     <TextField select style={{ marginBottom: 9, maxWidth: 180 }}
                        label="Criteria"
                        title={"Filter search results by " + criteria.alias}
                        slotProps={{
                           htmlInput: { id: "criteria-id" + i.toString() },
                           inputLabel: { htmlFor: "criteria-id" + i.toString() }
                        }}
                        value={criteria.value}
                        onChange={(event) => dropdownCriteriaChanged(criteriaKey, event)}
                     >
                        {Util_MUI.buildSelectMenuItems(criteria.values)}
                     </TextField>

                  </td>
               </tr>,
            );
         }
      }
      return jsx;
   }

   //Set render values.
   const styles: Default.iStyles = {
      clearButton: { border: '1px solid silver' },
   };

   return (
      <div className="app-flex-row-between">
         <table>
            <caption>Filters</caption>
            <tbody>
               {getDropdownFilters()}
            </tbody>
         </table>

         <IconButton style={styles.clearButton} color="primary" size="small" onClick={clearAllDropdownCriteria} disabled={clearDropdownsDisabled} title="Clear all dropdown search results filters" aria-label="clear-dropdowns">
            <Icon fontSize="small">clear</Icon>
         </IconButton>
      </div>
   ); //end return.

} //end function.
